import { useState, useEffect } from "react";

const arraysEqualUnordered = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  const aSorted = [...a].sort();
  const bSorted = [...b].sort();

  return aSorted.every(
    (val, i) => JSON.stringify(val) === JSON.stringify(bSorted[i])
  );
};

const isEqual = (a, b) => {
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    return arraysEqualUnordered(a, b);
  }
  if (a && b && typeof a === "object") {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key) => isEqual(a[key], b[key]));
  }
  return a === b;
};

const compareObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;

  return keys1.every((key) => isEqual(obj1[key], obj2[key]));
};

export default function useFormState(initial = {}) {
  const [formData, setFormData] = useState(initial);
  const [originalData, setOriginalData] = useState(initial);
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    const changed = !compareObjects(formData, originalData);
    setHasChanged(changed);
  }, [formData, originalData]);

  const setField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const loadInitialData = (data) => {
    setFormData(data);
    setOriginalData(data);
  };

  return {
    formData,
    setField,
    loadInitialData,
    hasChanged,
    setFormData,
  };
}
